

import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { FontSizes, FontWeights, Text as FabricText } from 'office-ui-fabric-react';

const Text = (props) => {

    const getColor = () => {
        return (props.color) ? props.color : undefined;
    }

    const getFontSize = () => {
        let size = FontSizes.size14;
        if (props.xSmall) {
            size = FontSizes.size10;
        }
        if (props.small) {
            size = FontSizes.size12;
        }
        if (props.large) {
            size = FontSizes.size18;
        }
        if (props.xLarge) {
            size = FontSizes.size20;
        }
        if (props.xxLarge) {
            size = FontSizes.size28;
        }
        if (props.mega) {
            size = FontSizes.size68;
        }
        return size;
    }

    const getFontWeight = () => {
        return (props.bold) ? FontWeights.semibold : FontWeights.regular;
    }

    const classNames = mergeStyleSets({
        root: {
            fontSize: getFontSize(),
            fontWeight: getFontWeight(),
            color: getColor()
        }
    });

    let className = classNames.root;
    if (props.className) {
        className = `${className} ${props.className}`;
    }
    return (
        <FabricText
            className={className}
            nowrap={!!props.ellipsis}
            block={!!props.ellipsis}
            title={props.title}
        >
            {props.children}
        </FabricText>
    );
};

export default Text;

